import React, { useCallback } from 'react';

import { CustomCheckboxInteface, CustomInputInteface } from '../../core/models/inputs';

interface Props {
  children: React.ReactNode;
  className?: string;
  onSubmit(): void;
  inputs: (CustomInputInteface | CustomCheckboxInteface)[];
}

function CustomForm({ children, className, onSubmit, inputs }: Props) {
  const validateForm = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      e.stopPropagation();
      const errors: number[] = [];

      inputs.forEach((input, i) => {
        if (!input.isValid) {
          if (i === 0) input.ref.current.focus();
          input.setShowError(true);
          errors.push(1);
        }
      });

      if (errors.length > 0) return;
      onSubmit();
    },
    [inputs],
  );

  return (
    <form className={className} onSubmit={validateForm}>
      {children}
    </form>
  );
}

export default CustomForm;
